import { render, staticRenderFns } from "./ViewAnalyticsClients.vue?vue&type=template&id=b085f052&scoped=true&"
import script from "./ViewAnalyticsClients.vue?vue&type=script&lang=js&"
export * from "./ViewAnalyticsClients.vue?vue&type=script&lang=js&"
import style0 from "./ViewAnalyticsClients.vue?vue&type=style&index=0&id=b085f052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b085f052",
  null
  
)

export default component.exports